export default __webpack_public_path__ + "static/media/im.626ad4bb.svg";